
import React, { useEffect } from "react";
import { IonPage, IonContent, useIonAlert} from '@ionic/react';
import EbioroLoadingLogo from "../../components/EbioroLoading/EbioroLoadingLogo";
import { useHistory } from "react-router";
import { useAppDispatch, useAppSelector } from "../../services/redux/hook";
import { Sep10ChallengeParams, WalletInfoState } from "../../types/types";
import { Networks } from "@stellar/stellar-sdk";
import { stellarApi } from "../../services/api/stellar";
import { receivedSep10Token } from "../../services/redux/slices/auth/sep10";
import { ebioroApi } from "../../services/api/ebioro/ebioro";
import * as Sentry from '@sentry/react';
import { setUser } from "../../services/redux/slices/user/user";
import { setLanguage } from "../../services/redux/slices/language/language";
import { useTranslation } from "react-i18next";
import { Preferences } from '@capacitor/preferences';
import { KeyManager } from "../../services/stellar/wallet-sdk";
import { CapacitorKeyStore } from "../../services/stellar/wallet-sdk/plugins/CapacitorStorage";
import { clearFlowContext } from "../../services/redux/slices/flow-context/flowContext";


const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';
const isTestnet = import.meta.env.VITE_isTestnet === 'true' ? true : false;

const InitPage: React.FC = () => {

    const history = useHistory();
    const dispatch = useAppDispatch();
    const [present] = useIonAlert();
    const { t, i18n } = useTranslation();
    const secureStorage = new CapacitorKeyStore();
    const keyManager = new KeyManager({ keyStore: secureStorage });
    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);
    
    const darkMode = useAppSelector((state) => state.theme.darkMode);
    
    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    useEffect(() => {
        init()
    }, [])


    const init = async () => {

        let keys = await keyManager.loadAllKeyIds();

        if (keys.length == 0) {
            history.push('/welcome')
        }

        else {

            // Check if we have wallet info in Redux state
            // If not, redirect to PIN lock to decrypt and load the keys
            if (!walletInfo.device_private_key || !walletInfo.account_key) {
                history.push('/pin/lock')
                return
            }

            // here the user is coming from the PIN lock with decrypted keys in Redux

            if (walletInfo.device_private_key && walletInfo.account_key) {

                let params: Sep10ChallengeParams;

                params = {
                    account: walletInfo.account_key as string,
                    home_domain: ebioroAuthDomain,
                    network: isTestnet ? Networks.TESTNET : Networks.PUBLIC,
                    privateKey: walletInfo.device_private_key
                }

                try {

                    const data = await dispatch(stellarApi.endpoints.sep10.initiate(params)).unwrap();

                    if (data) {

                        dispatch(receivedSep10Token(data));
                        await Preferences.set({
                            key: ebioroAuthDomain,
                            value: JSON.stringify(data),
                        });

                    }

                    // get the userInfoData

                    const user = await dispatch(ebioroApi.endpoints.getUserInfo.initiate({}, { forceRefetch: true })).unwrap();
                
                    dispatch(setUser(user));

                    if (user.locale == 'es' || user.locale == 'en') {
                        await i18n.changeLanguage(user.locale);
                        dispatch(setLanguage(user.locale.toLocaleLowerCase()))
                    }

                    // Clear flow context (PIN, redirects) now that setup is complete
                    dispatch(clearFlowContext());

                    history.push('/tabs/accounts');

                } catch (error) {

                    Sentry.captureException(JSON.stringify(error))

                    presentErrorAlert({ data: t('application.uncaught.ERROR') })
                    return

                }


            }
        }

    }

    return (
        <IonPage>
            <IonContent fullscreen={true} scrollY={false}>
                <div className="ion-text-center">
                    <div className="generateWalletPageWaitModal_logo-on-center">

                        <EbioroLoadingLogo
                            mainText=""
                            mainTextColor="primary"
                            subText=""
                            subTextColor="primary"
                            icon_color={darkMode?'white':undefined}
                        />
                    </div>

                </div>
            </IonContent>
        </IonPage>
    )

}

export default InitPage